// Initial Notes Data

const initialNotesData = [
  {
    id: 0,
    title: 'Enjoy!',
    text: 'And by the way: you can delete these notes and write your own ones instead! No go and record an activity of yours!',
    createdAt: Date.now() - 1400000000,
    updatedAt: null
  },
  {
    id: 1,
    title: 'These Features will arrive soon!',
    text: 'Export your tracks to various formats.\n– Use your own API keys for various services.\n– Sharing options.\n– Text-2-speech option for any text input.',
    createdAt: Date.now() - 1300000000,
    updatedAt: null
  },
  {
    id: 2,
    title: 'What are the disadvantages?',
    text: '– Since all the data is saved locally (using indexDB) the storage of your device will be used up.\n– No possibility of synchronisation between devices.',
    createdAt: Date.now() - 128000000,
    updatedAt: null
  },
  {
    id: 3,
    title: 'What are the advantages?',
    text: 'Nobody but you total control over your data.\n– Works even when you are offline (due to PWA technologies).\n– All the data is saved directly to your device and your device only (indexedDB). No Internet required.',
    createdAt: Date.now() - 100000000,
    updatedAt: null
  },
  {
    id: 4,
    title: 'Welcome to Geo Mover!',
    text: 'With Geo Mover you can track you tours using modern web technologies. "Why another such app" you say? Because this app does not interact with any servers. All your data stays on your phone, as far as this app is concerned.',
    createdAt: Date.now(),
    updatedAt: null
  }
];

export default initialNotesData;
